angular.module('unica_wiki.wiki_services', []);